module.exports = __webpack_public_path__ + "static/media/NewRequest.66ca981c.svg";